import { jsx as _jsx } from "react/jsx-runtime";
import { bemClassBuilder } from '@vista-digital/bem-class-builder';
import { observer } from 'mobx-react';
import { useFilmContext } from '../../../context/film/hooks/use-film-context';
import { useOccDisplayText } from '../../../context/occ/hooks/use-occ-display-text';
import { PromotedTag } from '../../../subcomponents/promoted-tag';
import { withComponentWrapper } from '../../../utils/with-component-wrapper';
import { defaultFilmPromotedTagProps, filmPromotedTagPropsValidator } from './types/props';
import { getLabelForTagType } from './utils/get-label-for-tag-type';
import { getPromotedTagTypeForFilm } from './utils/get-promoted-tag-type-for-film';
const b = bemClassBuilder('v-film-promoted-tag');
export const FilmPromotedTag = observer(props => {
    const { film: filmDisplayText } = useOccDisplayText();
    const { config, componentId } = props;
    const { filmAvailability } = useFilmContext();
    if (!filmAvailability)
        return null;
    const type = getPromotedTagTypeForFilm(filmAvailability, componentId);
    if (!type)
        return null;
    return (_jsx(PromotedTag, { className: b.block({ type }), label: getLabelForTagType(type, filmDisplayText), alignment: config.alignment }));
});
FilmPromotedTag.displayName = 'FilmPromotedTag';
/**
 * The **Film Promoted Tag** component renders the promoted tag for a film.
 *
 * If there is no applicable promoted tag for the film, the **Film Promoted Tag** component will not render.
 */
export const FilmPromotedTagComponent = withComponentWrapper(FilmPromotedTag, defaultFilmPromotedTagProps, filmPromotedTagPropsValidator);
